import { type Person } from '@/types/Person'

export function createPerson(data: Partial<Person> = {}): Person {
  const now = new Date()

  return {
    firstName: data.firstName ?? '',
    lastName: data.lastName ?? '',
    middleName: data.middleName ?? undefined,

    contactFor: data.contactFor ?? undefined,
    jobTitle: data.jobTitle ?? undefined,
    organizationId: data.organizationId ?? undefined,

    email: data.email ?? undefined,
    phone: data.phone ?? undefined,
    mobilePhone: data.mobilePhone ?? undefined,
    streetAddress: data.streetAddress ?? undefined,
    city: data.city ?? undefined,
    state: data.state ?? undefined,
    postalCode: data.postalCode ?? undefined,
    country: data.country ?? undefined,

    idNumber: data.idNumber ?? undefined,
    photoIdUrl: data.photoIdUrl ?? undefined,
    photoIdType: data.photoIdType ?? undefined,
    photoIdExpirationDate: data.photoIdExpirationDate ?? undefined,
    attachments: data.attachments ?? [],

    notes: data.notes ?? '',
    referredBy: data.referredBy ?? undefined,
    tags: data.tags ?? [],
    status: data.status ?? 'lead',
    type: data.type ?? 'supplier',
    engagementStage: data.engagementStage ?? 'uncontacted',
    source: data.source ?? 'manual',

    rating: data.rating ?? 0,
    lastTransactionDate: data.lastTransactionDate ?? null,

    isVerified: data.isVerified ?? false,
    isExempt: data.isExempt ?? false,
    isDeleted: data.isDeleted ?? false,

    createdAt: data.createdAt ?? now,
    updatedAt: data.updatedAt ?? now,
    createdBy: data.createdBy ?? null,
  }
}
